import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import store from "store";
import { initializeGA } from "utils/ga/gaHelper";
import App from "./App";
import "./i18n/i18n";
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(document.getElementById("root"));
initializeGA();
// !inDevelopMode && initializeGA();

root.render(
  <Provider store={store}>
    <App />
  </Provider>
);
reportWebVitals();
